import React from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppOverlay from "./components/WhatsAppOverlay";
import { ChatWidget } from "./components/ChatWidget";

function App() {
  return (
    <div className="App">
      <style>
        {`
          #content {
            margin-bottom: 0;
            padding-bottom: 0;
          }
          #content > *:last-child {
            margin-bottom: 24px !important;
            padding-bottom: 0 !important;
          }
        `}
      </style>

      <ScrollToTop />

      <Navbar />

      {/* Main Content */}
      <div id="content">
        <Outlet />
      </div>
      <Footer />
      <WhatsAppOverlay />
      <ChatWidget />
    </div>
  );
}
export default App;
